import React, { useState } from 'react'
import { ThemeContext } from "./context";
import Navbar from "./Navbar";
import Playground from './components/Playground';
import Sidepanel from './components/Sidepanel';
import './style.css'

export default function Home() {
    const defaultTheme = { currentTheme: "l" }
    const [theme, setTheme] = useState(defaultTheme)
    const data={...theme, setTheme}
  return (
    <ThemeContext.Provider value={data}>
      <Navbar />
      <div className='secondPanel'>
          <Sidepanel />
          <Playground />
      </div>
    </ThemeContext.Provider>
  )
}
